<template>
  <a-drawer
    :title="$t('title.loadingOrderEdit')"
    placement="right"
    :closable="false"
    :visible="visible"
    width="25%"
    @close="onClose">
    <a-spin :spinning="confirmLoading">
      <a-form-model ref="form" :model="args">
        <a-form-model-item :label="$t('business.label.loadingOrderNo')" :label-col="labelCol" :wrapper-col="wrapperCol" prop="orderNo">
          <div v-for="no in  args['orderNos']">
            <a-input style="width: 100%" :value="no" readOnly />
          </div>
        </a-form-model-item>
        <a-form-model-item :label="$t('business.label.deliver')" :label-col="labelCol" :wrapper-col="wrapperCol" prop="deliver">
          <a-input-search v-model="args.deliverer" readOnly @dblclick="()=>this.$refs.deliverModal.open({'role.name':'配送员'})" @search="()=>this.$refs.deliverModal.open({'role.name':'配送员'})" />
          <user-modal ref="deliverModal" @change="(e)=>{this.args.deliverer=e.length===0?null:e[0].name}" />
        </a-form-model-item>
        <a-form-model-item :label="$t('business.label.vehicleNo')" :label-col="labelCol" :wrapper-col="wrapperCol" prop="vehicleNo">
          <a-input-search v-model="args.vehicle.no" readOnly @dblclick="()=>this.$refs.vehicleModal.open()" @search="()=>this.$refs.vehicleModal.open()" />
          <vehicle-modal ref="vehicleModal" @change="(e)=>{this.args.vehicle=e.length===0?{id:null,no:null}:e[0]}" />
        </a-form-model-item>
        <a-form-model-item :label="$t('business.label.vehicleInPlaceStatus')" :label-col="labelCol" :wrapper-col="wrapperCol" prop="vehicleInPlaceStatus">
          <a-input style="width: 100%" v-model="args.vehicleInPlaceStatus" />
        </a-form-model-item>
        <a-form-model-item :label="$t('business.label.driver')" :label-col="labelCol" :wrapper-col="wrapperCol" prop="driver">
          <a-input-search v-model="args.driver" readOnly @dblclick="()=>this.$refs.driverModal.open({'role.name':'司机'})" @search="()=>this.$refs.driverModal.open({'role.name':'司机'})" />
          <user-modal ref="driverModal" @change="(e)=>{this.args.driver=e.length===0?null:e[0].name}" />
        </a-form-model-item>
        <a-form-model-item :label="$t('business.label.phone')" :label-col="labelCol" :wrapper-col="wrapperCol" prop="driverPhone">
          <a-input style="width: 100%" v-model="args.driverPhone" />
        </a-form-model-item>
        <a-form-model-item :label="$t('business.label.dock')" :label-col="labelCol" :wrapper-col="wrapperCol" prop="dock">
          <a-input-search v-model="args.dock.no" readOnly @dblclick="()=>$refs.dockModal.open({locationType:3})" @search="()=>$refs.dockModal.open({locationType:3})" />
          <location-modal ref="dockModal" @change="(e)=>{args.dock=e.length===0?{id:null,no:null}:e[0]}" />
        </a-form-model-item>
        <a-form-model-item :label="$t('business.label.departureTime')" :label-col="labelCol" :wrapper-col="wrapperCol" prop="departureTime">
          <a-date-picker
            v-model="args.departureTime"
            show-today
            style="width: 100%"
            valueFormat="YYYY-MM-DD" />
        </a-form-model-item>
        <a-form-model-item :label="$t('business.label.notes')" :label-col="labelCol" :wrapper-col="wrapperCol" prop="notes">
          <a-input-search v-model="args.notes" readOnly @dblclick="()=>$refs.noteModal.open(args.notes)" @search="()=>$refs.noteModal.open(args.notes)" />
          <text-area-modal ref="noteModal" :title="$t('business.label.notes')" @change="(e)=>{args.notes=e}" :min-rows="20" :max-rows="30"></text-area-modal>
        </a-form-model-item>
        <a-form-model-item>
          <a-button type="primary" @click="onClose" style="float: right">
            {{ $t('button.cancel') }}
          </a-button>
          <a-button type="primary" @click="confirm" style="float: right;margin-right: 10px">
            {{ $t('button.confirm') }}
          </a-button>
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </a-drawer>
</template>

<script>
import { post } from '@/api/Api'
import Vue from 'vue'
import { WAREHOUSE } from '@/store/mutation-types'
import Api from '@/api'
import UserModal from '@/views/modal/UserModal.vue'
import LocationModal from '@/views/modal/LocationModel.vue'
import VehicleModal from '@/views/modal/VehicleModal.vue'
import TextAreaModal from '@/views/modal/TextAreaModal.vue'

export default {
  name: 'LoadingOrderEditModal',
  components: { TextAreaModal, VehicleModal, LocationModal, UserModal },
  data() {
    return {
      visible: false,
      confirmLoading: false,
      warehouse: Vue.ls.get(WAREHOUSE),
      args: {
        ids: [],
        orderNos: [],
        dispatcher: null,
        deliverer: null,
        driver: null,
        driverPhone: null,
        vehicleInPlaceStatus: null,
        departureTime: null,
        notes: null,
        vehicle: {
          id: null,
          no: null
        },
        dock: {
          id: null,
          no: null
        }
      },
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      rules: {},
      order: null,
      record: null
    };
  },
  methods: {
    open(records) {
      console.log(records);
      if (records.length > 0) {
        records.forEach(record => {
          this.args.ids.push(record.order.id);
          this.args.orderNos.push(record.order.no);
        });
      }
      if (records.length === 1) {
        this.args.dispatcher = records[0].order.dispatcher;
        this.args.deliverer = records[0].order.deliverer;
        this.args.driver = records[0].order.driver;
        this.args.driverPhone = records[0].order.driverPhone;
        this.args.vehicleInPlaceStatus = records[0].order.vehicleInPlaceStatus;
        this.args.departureTime = records[0].order.departureTime;
        this.args.notes = records[0].order.notes;
        this.args.vehicle = records[0].vehicle === null || records[0].vehicle === undefined ? this.args.vehicle : records[0].vehicle;
        this.args.dock = records[0].dock === null || records[0].dock === undefined ? this.args.dock : records[0].dock;
      }
      this.visible = true;
    },
    confirm() {
      this.$refs.form.validate((success) => {
        if (success) {
          this.confirmLoading = true;
          let checkInData = {
            ids: this.args.ids,
            dispatcher: this.args.dispatcher,
            deliverer: this.args.deliverer,
            driver: this.args.driver,
            driverPhone: this.args.driverPhone,
            vehicleInPlaceStatus: this.args.vehicleInPlaceStatus,
            departureTime: this.args.departureTime,
            notes: this.args.notes,
            'vehicle.id': this.args.vehicle.id,
            'dock.id': this.args.dock.id
          };
          post(Api.deliveryCheckIn, {}, checkInData).then(res => {
            if (res.success) {
              this.$message.success('保存成功');
              this.$emit('postSave')
              this.onClose();
            }
          }).finally(() => {
            this.confirmLoading = false;
          });
        }
      });
    },
    onClose() {
      this.visible = false;
      this.clear();
    },
    clear() {
      this.args = {
        ids: [],
        orderNos: [],
        dispatcher: null,
        deliverer: null,
        driver: null,
        vehicle: {
          id: null,
          no: null
        },
        dock: {
          id: null,
          no: null
        },
        driverPhone: null,
        vehicleInPlaceStatus: null,
        departureTime: null,
        notes: null
      };
    }
  }
};
</script>